import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl, FormControl } from "@angular/forms";

@Pipe({
    name: "getControl",
    standalone: false
})
export class GetControlPipe implements PipeTransform {
  transform(value: AbstractControl, name: string): FormControl {
    return value.get(name) as FormControl;
  }
}
